<script setup>
import { ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { SYSTEM_PARAMETERS } from 'dashboard/helper/systemParameters';

// `format`: 'liquid' insere {{ contact.name }} (mensagens); 'named' insere {{nome}}
// (variáveis nomeadas dos templates da Meta).
const props = defineProps({
  format: { type: String, default: 'liquid' },
  disabled: Boolean,
});
const emit = defineEmits(['insert']);
const open = ref(false);
const up = ref(false);
const root = ref(null);
// Abre para cima quando não cabe abaixo do botão (ex.: rodapé no fim do modal).
const MENU_HEIGHT = 340;
const toggle = () => {
  open.value = !open.value;
  if (!open.value) return;
  const rect = root.value?.getBoundingClientRect();
  up.value =
    !!rect &&
    window.innerHeight - rect.bottom < MENU_HEIGHT &&
    rect.top > MENU_HEIGHT;
};
onClickOutside(root, () => {
  open.value = false;
});
const tokenFor = parameter =>
  props.format === 'named' ? `{{${parameter.name}}}` : parameter.liquid;
const choose = parameter => {
  emit('insert', tokenFor(parameter));
  open.value = false;
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template -->
  <div ref="root" class="relative inline-flex" :class="{ '!z-50': open }">
    <button
      type="button"
      class="inline-flex h-7 items-center gap-1 rounded-md border border-n-weak bg-n-alpha-1 px-2 text-xs font-medium text-n-slate-11 transition hover:bg-n-alpha-2 hover:text-n-slate-12 disabled:opacity-50"
      :disabled="disabled"
      :aria-expanded="open"
      aria-haspopup="menu"
      @click="toggle"
    >
      <span class="i-lucide-braces size-3.5" aria-hidden="true" />
      Parâmetros
      <span class="i-lucide-chevron-down size-3" aria-hidden="true" />
    </button>
    <div
      v-if="open"
      role="menu"
      class="absolute right-0 z-50 w-72 max-w-[calc(100vw-2rem)] rounded-xl border border-n-weak bg-n-solid-2 p-1.5 shadow-lg"
      :class="up ? 'bottom-full mb-1' : 'top-full mt-1'"
    >
      <p class="mb-1 px-2 pt-1 text-xs font-medium text-n-slate-10">
        Inserir dado do sistema
      </p>
      <ul class="m-0 grid max-h-72 list-none gap-0.5 overflow-y-auto p-0">
        <li v-for="parameter in SYSTEM_PARAMETERS" :key="parameter.name">
          <button
            type="button"
            role="menuitem"
            class="grid w-full gap-0.5 rounded-lg px-2 py-1.5 text-left hover:bg-n-alpha-2 focus-visible:bg-n-alpha-2 focus-visible:outline-none"
            @click="choose(parameter)"
          >
            <span class="text-sm font-medium text-n-slate-12">
              {{ parameter.label }}
            </span>
            <code class="truncate text-xs text-n-slate-10">
              {{ tokenFor(parameter) }}
            </code>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>
